import React from "react";
import { MultiColumnList } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
export var PublisherGenericProductNumbersTable = function (_a) {
    var numbers = _a.numbers;
    return (React.createElement(MultiColumnList, { contentData: numbers, columnMapping: {
            id: "",
            fullFormattedValue: (React.createElement(FormattedMessage, { id: "ui-br-agency.publisher.genericProductNumbers.field.label" })),
        }, formatter: {
            id: function (item) { var _a; return (_a = item.id) !== null && _a !== void 0 ? _a : "-"; },
            fullFormattedValue: function (item) { var _a; return (_a = item.fullFormattedValue) !== null && _a !== void 0 ? _a : "-"; },
        }, visibleColumns: ["fullFormattedValue"], interactive: false }));
};
